import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './AddContact.scss';
import iconMinus from './images/removeContact.svg';

const AddContact = ({
  value = '',
  placeholder = 'מספר טלפון של איש קשר',
  hasError = false,
  errorMessage = '',
  isLoading = false,
  isDeleteMode = false,
  onCheck,
  onClear,
  onChange,
  onFocus,
  onBlur,
}) => {
  const handleButtonClick = () => {
    if (isDeleteMode && onClear) {
      onClear();
    } else if (onCheck) {
      onCheck(value);
    }
  };

  const containerClassName = `add-contact ${hasError ? 'add-contact--error' : ''} ${isDeleteMode ? 'add-contact--delete-mode' : ''}`;

  // Delete mode: show as a result card
  if (isDeleteMode) {
    return (
      <div className={containerClassName}>
        <div className='add-contact__phone-display'>{value}</div>
        <button className='add-contact__delete-button' onClick={handleButtonClick} disabled={isLoading} type='button'>
          {isLoading ? (
            <span className='add-contact__spinner' />
          ) : (
            <div className='add-contact__minus-icon'>
              <Image src={iconMinus} alt='' />
            </div>
          )}
        </button>
        {hasError && errorMessage && <div className='add-contact__error-message'>{errorMessage}</div>}
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <input
        type='tel'
        className='add-contact__input'
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={isLoading}
      />
      <button className='add-contact__button' onClick={handleButtonClick} disabled={isLoading} type='button'>
        {isLoading ? <span className='add-contact__spinner' /> : <span className='add-contact__button-text'>הוספה</span>}
      </button>
      {hasError && errorMessage && <div className='add-contact__error-message'>{errorMessage}</div>}
    </div>
  );
};

export default AddContact;
